import React, { useEffect, useState } from 'react';
import './App.css';
import AppRouter from './router';
import store from './store';
import { Provider, useSelector } from 'react-redux';
import firebase from 'firebase/app';
import * as dotenv from 'dotenv';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { isLoggedIn } from './utils/redux';
import AuthIsLoaded from './views/routing/AuthIsLoaded';

dotenv.config();

const rrfProps = {
  firebase: firebase,
  config: {},
  dispatch: store.dispatch
};


function App() {
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <AuthIsLoaded>
          <div className="App">
            <AppRouter />
          </div>
        </AuthIsLoaded>
      </ReactReduxFirebaseProvider>
    </Provider>
  );
}

export default App;
